//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import func from '@/utils/preload';
export default {
  props: {
    childNodeP: {
      type: Object | String,
      default: ''
    }
  },
  data: function data() {
    return {
      visible: false
    };
  },
  beforeCreate: function beforeCreate() {
    this.$vue.prototype.$func = func;
  },
  methods: {
    addType: function addType(type) {
      this.visible = false;
      if (type != 4) {
        var data;
        if (type == 1) {
          data = {
            nodeName: '审核人',
            error: false,
            type: '1',
            onlyValue: this.$func.onlyValue(),
            settype: '2',
            selectMode: '0',
            selectRange: '0',
            directorLevel: '1',
            directorOrder: '1',
            examineMode: '3',
            noHanderAction: '1',
            examineEndDirectorLevel: '0',
            childNode: this.childNodeP,
            nodeUserList: []
          };
          this.$emit('update:childNodeP', data);
        } else if (type == 2) {
          data = {
            nodeName: '抄送人',
            type: 2,
            onlyValue: this.$func.onlyValue(),
            ccSelfSelectFlag: '1',
            departmentHead: [],
            childNode: this.childNodeP,
            nodeUserList: []
          };
        }
        this.$emit('update:childNodeP', data);
      } else {
        this.$emit('update:childNodeP', {
          nodeName: '路由',
          type: 4,
          onlyValue: this.$func.onlyValue(),
          childNode: null,
          conditionNodes: [{
            nodeName: '条件1',
            error: true,
            type: 3,
            onlyValue: this.$func.onlyValue(),
            priorityLevel: '1',
            conditionList: [],
            isDefault: false,
            nodeUserList: [],
            childNode: this.childNodeP
          }, {
            nodeName: '默认条件',
            type: 3,
            onlyValue: this.$func.onlyValue(),
            priorityLevel: '2',
            conditionList: [],
            isDefault: true,
            nodeUserList: [],
            childNode: null
          }]
        });
      }
    }
  }
};